import Spider from "../../api/Spider";
import { spiderTypes } from "../types/spider.types";

export const getBrands = (vehicleType, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_MARCAS });
  try {
    const { body } = await Spider.getBrands(vehicleType);
    if (cb) {
      cb(body);
    }
    dispatch({ type: spiderTypes.GET_MARCAS_SUCCESS, payload: body || [] });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_MARCAS_FAILED, error });
  }
};

export const getModels = (vehicleType, id, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_MODELOS });
  try {
    const { body } = await Spider.getModels(vehicleType, id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: spiderTypes.GET_MODELOS_SUCCESS, payload: body || [] });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_MODELOS_FAILED, error });
  }
};

export const getChannel = (cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_CHANNEL_REQUEST });
  try {
    const { body } = await Spider.getChannel();
    if (cb) {
      cb(body);
    }
    dispatch({ type: spiderTypes.GET_CHANNEL_SUCCESS, payload: body || [] });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_CHANNEL_FAILED, error });
  }
};